import { includesEnterprise, enterpriseDepViews } from '@rebuild/hooks/cache';

/**
 * 页面缓存
 *
 * key: String 需要缓存的页面、路由的name要和页面组件的name一致
 * value: Array 仅在设置的跳转路由里面缓存页面，为空则表示所有跳转都缓存
 */

const routeName = {
	attend_meeting_check: [
		'attend_meeting_sign',
		'attend_meeting_promise',
		'attend_meeting_search',
		'investor_entourage'
	],

	self_meeting_check: ['self_meeting_search'],

	roadshow_home: ['roadshow_sign', 'roadshow_promise'],

	roadshow_record: ['roadshow_sign', 'roadshow_promise'],

	enrollment_join: ['enrollment_sign', 'enrollment_promise', 'enrollment_search'],

	institution_investor_aut_check: ['institution_investor_aut_search'],

	user_index: [],

	institute_user: [],

	member_home: [],

	flagship_index: ['roadshow_home', 'roadshow_record'],

	topic_index: ['topic_home', 'topic_detail', 'topic_collection', 'topic_strategy'],

	home: [],

	roadshow_preview: ['roadshow_home', 'roadshow_record'],

	roadshow_list: ['roadshow_home', 'roadshow_record'],

	roadshow_public_company: ['roadshow_home', 'roadshow_record'],

	roadshow_vip_institution_list: ['roadshow_home', 'roadshow_record'],

	roadshow_member_list: ['roadshow_home', 'roadshow_record'],

	topic_home: ['roadshow_home', 'roadshow_record'],

	topic_strategy: ['roadshow_home', 'roadshow_record'],

	topic_industry: ['roadshow_home', 'roadshow_record'],

	columncourse: ['roadshow_home', 'roadshow_record', 'course_home', 'column_home'],

	multiple_roadshow: ['roadshow_home', 'roadshow_record'],

	character_home: ['roadshow_home', 'roadshow_record'],

	institute_home: [],

	'research_logs-list': [],

	roadshow_index: ['character_home', 'flagship_index'],

	flagship_list: ['flagship_index'],

	// irm
	'attend-meeting-check': [
		'attend_meeting_search',
		'attend_meeting_sign',
		'attend_meeting_promise',
		'investor_entourage'
	],

	'special-apply': ['attend_meeting_search', 'attend_meeting_sign', 'attend_meeting_promise', 'investor_entourage'],

	investor_appointment: ['attend_meeting_promise', 'attend_meeting_sign', 'investor_entourage', 'areaCode_index'],

	investor_entourage: ['areaCode_index'],

	'attend-meeting-zoom': ['attend_meeting_search', 'areaCode_index', 'attend_meeting_sign', 'attend_meeting_promise']
};

export default {
	beforeRouteEnter(to, from, next) {
		next(vm => {
			if (routeName[to.name]) {
				vm.$store.commit('setKeepAlive', to.name);
			}
			if (includesEnterprise.includes(to.name)) {
				// 企业号入口
				vm.$store.commit('setKeepAlive', 'DynamicLayout');
			}
		});
		next();
	},
	beforeRouteLeave(to, from, next) {
		let name = routeName[from.name];
		if (name && name.length && !name.includes(to.name)) {
			this.$store.commit('removeKeepAlive', from.name);
		}
		if (!includesEnterprise.includes(from.name) && !enterpriseDepViews.includes(from.name)) {
			// 企业号入口
			this.$store.commit('removeKeepAlive', 'DynamicLayout');
		}
		next();
	}
};
